import { FunctionComponent } from "react";
import { Button } from "../../../components/Button";
import { SmallModal } from "../../../components/sideModal/Modal";
import { formatDate, formatTime } from "../../../../services/dateService";
import { OverlapPair, PerListOverlap } from "./types";

interface Props {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    newVsNewOverlaps: OverlapPair[];
    newVsExistingOverlaps: PerListOverlap[];
}

const renderPair = (pair: OverlapPair, key: string) => (
    <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', whiteSpace: 'nowrap' }}>
        <span><strong>{pair.streamA.name}</strong> ({formatDate(pair.streamA.startTime)} {formatTime(pair.streamA.startTime)})</span>
        <span>&#8596;</span>
        <span><strong>{pair.streamB.name}</strong> ({formatDate(pair.streamB.startTime)} {formatTime(pair.streamB.startTime)})</span>
    </div>
);

const OverlapConfirmModal: FunctionComponent<Props> = ({ show, onClose, onConfirm, newVsNewOverlaps, newVsExistingOverlaps }) => (
    <SmallModal stretch={true} show={show} title="Please be noted" onRequestClose={onClose}>
        <p>The following streams have overlapping times:</p>
        {newVsNewOverlaps.length > 0 && <>
            <p style={{ textAlign: 'left', marginTop: '12px' }}><strong>New vs New:</strong></p>
            <div style={{ margin: '4px 0' }}>
                {newVsNewOverlaps.map((pair, index) => renderPair(pair, `nn-${index}`))}
            </div>
        </>}
        {newVsExistingOverlaps.map((listOverlap, listIndex) => (
            listOverlap.overlaps.length > 0 && <div key={`list-${listIndex}`}>
                <p style={{ textAlign: 'left', marginTop: '12px' }}><strong>New vs Existing ({listOverlap.listName}):</strong></p>
                <div style={{ margin: '4px 0' }}>
                    {listOverlap.overlaps.map((pair, index) => renderPair(pair, `ne-${listIndex}-${index}`))}
                </div>
            </div>
        ))}
        <div className="modal-btn-group">
            <Button color="gray" label="Cancel" onClick={onClose} />
            <Button color="green" label="Process" onClick={onConfirm} />
        </div>
    </SmallModal>
);

export default OverlapConfirmModal;
